import { RootState } from 'store';
import { TIsLoading } from 'common/types/common';
import {
  checkIsDoneStatus,
  checkIsLoadStatus,
  checkIsErrorStatus
} from 'common/utils/loadingStatus';

import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EMPTY_ARRAY } from 'common/constants';
import { STATE } from '../types/state';

export const selectorAllStationsStatusLoading = (state: RootState): TIsLoading => {
  const { allStations: { isLoading } } = state[STATE];
  return isLoading;
};

export const selectAllStationsIsDone = (state: RootState): boolean => (
  checkIsDoneStatus(selectorAllStationsStatusLoading(state))
);

const useAllStationsLoadingStatus = () => {
  const allStationsLoadingStatus = useSelector((state: RootState) => state[STATE].allStations.isLoading);
  return allStationsLoadingStatus;
};

export const useIsAllStationsDone = () => {
  const allStationsLoadingStatus = useAllStationsLoadingStatus();
  return checkIsDoneStatus(allStationsLoadingStatus);
};

export const isAllStationsLoading = (state: RootState): boolean => (
  checkIsLoadStatus(selectorAllStationsStatusLoading(state))
);

export const isAllStationsError = (state: RootState): boolean => (
  checkIsErrorStatus(selectorAllStationsStatusLoading(state))
);

export const useAllStations = () => useSelector((state: RootState) => state[STATE].allStations.data);

export const useGetStationsByBrandCode = () => {
  const stations = useAllStations() || EMPTY_ARRAY;

  const getStationsByBrandCode = useCallback((brandCode: string) => (
    stations.filter(station => station.brandCode === brandCode)
  ), [stations]);

  return getStationsByBrandCode;
};